import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { CRMCanalVenda } from 'src/app/models/crm/crmcanal-venda';

@Injectable({
  providedIn: 'root'
})
export class CrmcanalVendaService {

  constructor(private http: HttpClient) { }

  consultarCanaisVenda() {
    return this.http.get<CRMCanalVenda[]>(globals.apiUrl + '/api/CRMCanalVenda/Lista');
  }

  consultarCanaisVendaComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, statusCadastro) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    if (statusCadastro !== null) {
      parametros = parametros.set('statusCadastro', statusCadastro);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CRMCanalVenda/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdCanalVenda(idCanalVenda) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMCanalVenda/Buscar',
      { params: new HttpParams().set('id', idCanalVenda) });
  }

  salvar(canalVenda: CRMCanalVenda) {
    return this.http.post(globals.apiUrl + '/api/CRMCanalVenda/Salvar', canalVenda);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CRMCanalVenda/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
